import _ from 'lodash';

import chartUtils from './chartUtils';

export function getBreakDownList(dashboards = [], chart) {
  const isCycletime = chart === 'cycletime';
  
  if (dashboards) {
    const list = _(dashboards)
      .map(d => d.allCustomFields)
      .flatten()
      .groupBy('name')
      .map((value, key) => ({ name: key, id: _.map(value, v => v.id) }))
      .value();

    const flags = { azure: false, azureFile: false, jira: false, jiraFile: false, trello: false, asana: false, file: false };
    _.forEach(dashboards, d => {
      switch (d.application) {
        case 'file': 
          if (!d.isCsv && d.isAzure) flags.azureFile = true;
          if (!d.isCsv && !d.isAzure) flags.jiraFile = true;
          flags.file = true;
          break;
        case 'azure': flags.azure = true; break;
        case 'jira': flags.jira = true; break;
        case 'trello': flags.trello = true; break;
        case 'asana': flags.asana = true; break;
      }
    });

    if (flags.azureFile || flags.azure) {
      list.push({ name: 'Work item types', id: ['labels'] });
    }
    if (flags.jiraFile || flags.jira) {
      list.push({ name: 'Priorities', id: ['labels'] });
    }
    if (flags.asana) {
      list.push({ name: 'Tags', id: ['labels'] });
    }
    if (flags.trello) {
      list.push({ name: 'Labels', id: ['labels'] });
    }

    if (isCycletime) {
      if (flags.azure) list.push({ name: 'Columns', id: ['statuses'] });
      if (flags.asana) list.push({ name: 'Sections', id: ['statuses'] });
      if (flags.jira || flags.file) list.push({ name: 'Statuses', id: ['statuses'] });
      if (flags.trello) list.push({ name: 'Lists', id: ['statuses'] });
    }

    return _(list)
      .groupBy('name')
      .map((value, key) => ({
        name: key,
        id: _.uniq(_.flatten(_.map(value, v => v.id)))
      }))
      .orderBy('name')
      .value();
  }
  return [];
}

export default {
  getBreakDownList
}

export const FULL_SCREEN_TRENDS = {
  ctt: 'avgCt',
  tht: 'throughput',
  wip: 'wip',
  wat: 'avgWat',
  percentile: 'percentiles',
  fe: 'flowEfficiency'
};

export function reportHasNoData(trends, loading) {
  return !loading && !chartUtils.hasValues(_.get(trends, 'throughput')) && !chartUtils.hasValues(_.get(trends, 'wip'));
}

export function leavesFullScreen(fullScreen, trends, loading) {
  return !!fullScreen && !loading && !chartUtils.hasValues(_.get(trends, FULL_SCREEN_TRENDS[fullScreen]));
}

export function cardIsEmpty(series, loading) {
  return !loading && !chartUtils.hasValues(series);
}

export function averageWip(wipSeries) {
  const days = wipSeries && wipSeries[0] && wipSeries[0].data;
  if (!days || !days.length) {
    return null;
  }
  return Math.round(_.meanBy(days, 'y'));
}
